export const SET_VINCULO_PESSOA_EMPRESA = 'SET_VINCULO_PESSOA_EMPRESA';
export const LOADING_VINCULOS = 'LOADING_VINCULOS';
export const SET_FUNCIONARIO_VINCULADO_INFO = 'SET_FUNCIONARIO_VINCULADO_INFO';